import {Component, ElementRef, forwardRef, Input, Optional, Self} from '@angular/core';
import { NgControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldControl, MatFormField, MatLabel, MatSuffix, MatError, MatHint } from '@angular/material/form-field';
import {AsYouType} from 'libphonenumber-js';
import {PhoneNumbersUtils} from '../../core/utilities/phone-numbers-helpers';
import {MatBaseInputComponent} from '../mat-base-input.component';
import { MatFormFieldFix } from '../mat-form-field/mat-form-field-fix';
import { MatInput } from '@angular/material/input';
import { NgIf } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';

@Component({
    selector: 'app-mat-phone-number-input',
    providers: [
        { provide: MatFormFieldControl, useExisting: forwardRef(() => MatPhoneNumberInputComponent) },
    ],
    template: `
    <mat-form-field class="regular-form-field"
                    [appearance]="appearance"
                    (focusin)="onFocusIn($event)"
                    (focusout)="onFocusOut($event)">
      <mat-label>
        {{label}}
      </mat-label>
      <input matInput
             [formControl]="formControl"
             [value]="formattedValue"
             type="text"
             [id]="_id"
             [name]="name"
             [placeholder]="placeholder ? placeholder : inlineLabel ? label : ''"
             (input)="onChange($event.target['value'])"
             autocomplete="off"
      >
      <mat-icon matSuffix class="explanation" *ngIf="!!explanation" matTooltip="{{explanation}}">info_outline</mat-icon>
      <button mat-icon-button matSuffix type="button" *ngIf="suffixIcon" (click)="onSuffixClicked.emit($event)"
              [matTooltip]="suffixTooltip">
        <mat-icon matSuffix>{{suffixIcon}}</mat-icon>
      </button>
      <mat-error *ngIf="formControl?.invalid">{{firstError()}}</mat-error>
      <mat-hint align="start" *ngIf="!formControl?.invalid">{{infoText}}</mat-hint>
    </mat-form-field>
  `,
    standalone: true,
    imports: [MatFormField, MatFormFieldFix, MatLabel, MatInput, FormsModule, ReactiveFormsModule, NgIf, MatIcon, MatSuffix, MatTooltip, MatIconButton, MatError, MatHint]
})
export class MatPhoneNumberInputComponent extends MatBaseInputComponent {

  asYouType = new AsYouType('US');
  formattedValue: string;

  @Input()
  useNationalInput = false;

  constructor(@Optional() @Self() public ngControl: NgControl, public _elementRef: ElementRef<HTMLElement>) {
    super(ngControl, _elementRef);
  }

  writeValue(obj: any): void {
    console.log('write', obj);
    this.value = obj;
    this.asYouType.reset();
    const formattedValue = this.asYouType.input(this.value || '');
    const numberObj = this.asYouType.getNumber();

    if (PhoneNumbersUtils.isShortCode(this.value)) {
      this.formattedValue = numberObj ? numberObj.nationalNumber as string : this.value;
    } else {
      this.formattedValue = formattedValue;
    }
  }

  onChange(event) {
    console.log('write', event);
    this.asYouType.reset();
    const formattedValue = this.asYouType.input(event || '');
    const numberObj = this.asYouType.getNumber();

    if (PhoneNumbersUtils.isShortCode(event)) {
      this.formattedValue = numberObj ? numberObj.nationalNumber as string : event;
    } else {
      this.formattedValue = formattedValue;
    }

    this.onTouched();

    if (PhoneNumbersUtils.isShortCode(event) || this.useNationalInput) {
      console.log(numberObj.nationalNumber, numberObj.number, numberObj);
      this.propagateChange(numberObj ? numberObj.nationalNumber as string : event);
    } else if (numberObj) {
      this.propagateChange(numberObj.number as string);
    } else {
      this.propagateChange(undefined);
    }
  }
}
